"use strict";

require("core-js/modules/es.array.includes");

require("core-js/modules/es.string.includes");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onFederatedMsg = onFederatedMsg;
exports.handlers = void 0;

var _packingSlips = require("./packingSlips");

var _state = require("./state");

var _filters = require("./filters");

var _postal = _interopRequireDefault(require("@mtt/postal"));

var _extend = _interopRequireDefault(require("lodash/extend"));

var _without = _interopRequireDefault(require("lodash/without"));

var _sendQueue = _interopRequireDefault(require("./sendQueue"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handlers = {
  "federation.ping": function federationPing(data
  /*, callback */
  ) {
    data.source.setInstanceId(data.packingSlip.instanceId);

    if (data.source.handshakeComplete) {
      data.source.sendPong(data.packingSlip);
    } else {
      data.source.sendBundle([(0, _packingSlips.getPackingSlip)("pong", data.packingSlip), (0, _packingSlips.getPackingSlip)("ping")]);
    }
  },
  "federation.pong": function federationPong(data) {
    data.source.handshakeComplete = true;
    data.source.setInstanceId(data.packingSlip.instanceId);

    if (data.source.pings[data.packingSlip.pingData.ticket]) {
      data.source.pings[data.packingSlip.pingData.ticket].callback({
        ticket: data.packingSlip.pingData.ticket,
        instanceId: data.packingSlip.instanceId,
        source: data.source
      });
      data.source.pings[data.packingSlip.pingData.ticket] = undefined;
    }

    if (!_state.state._clients.includes(data.packingSlip.instanceId)) {
      _state.state._clients.push(data.packingSlip.instanceId);
    }

    _postal.default.publish({
      channel: "postal.federation",
      topic: "client.federated",
      data: {
        remoteId: data.source.instanceId,
        localId: _postal.default.instanceId(),
        transport: data.transport
      }
    });

    (0, _sendQueue.default)();
  },
  "federation.disconnect": function federationDisconnect(data) {
    _state.state._clients = (0, _without.default)(_state.state._clients, data.source.instanceId);
    (0, _state.disconnect)({
      transport: data.source.transportName,
      instanceId: data.source.instanceId,
      doNotNotify: true
    });
  },
  "federation.message": function federationMessage(data) {
    var env = data.packingSlip.envelope;

    if ((0, _filters.matchesFilter)(env.channel, env.topic, "in")) {
      env.lastSender = data.packingSlip.instanceId;

      _postal.default.publish(env);
    }
  },
  "federation.bundle": function federationBundle(data) {
    data.packingSlip.packingSlips.forEach(function (slip) {
      onFederatedMsg((0, _extend.default)({}, data, {
        packingSlip: slip
      }));
    });
  }
};
exports.handlers = handlers;

function onFederatedMsg(data) {
  if (!_state.state._ready) {
    _state.state._inboundQueue.push(data);

    return;
  }

  if (Object.prototype.hasOwnProperty.call(handlers, data.packingSlip.type)) {
    handlers[data.packingSlip.type](data);
  } else {
    throw new Error("postal.federation does not have a message handler for '" + data.packingSlip.type + "'.");
  }
}